import { apiRequest } from './auth'

type ApiEnvelope<T> = { data: T; meta: { requestId: string; total?: number } }

export type FoodRecord = {
  id: string
  feature: string
  name: string
  details: string
  serviceTime: string
  quantity: number
  status: string
  values: string[]
  version: number
  createdAt: string
  updatedAt: string
}

export type FoodSummary = {
  mealsToday: number
  enrolledClients: number
  specialDiets: number
  missingCounts: number
  totalRecords: number
}

export type SaveFoodRecordInput = {
  feature: string
  name: string
  details?: string
  serviceTime?: string
  quantity?: number
  status?: string
}

export async function getFoodSummary(): Promise<FoodSummary> {
  const response = await apiRequest<ApiEnvelope<FoodSummary>>('food/summary')
  return response.data
}

export async function listFoodRecords(feature: string): Promise<FoodRecord[]> {
  const params = new URLSearchParams({ feature })
  const response = await apiRequest<ApiEnvelope<FoodRecord[]>>(`food/records?${params}`)
  return response.data
}

export async function createFoodRecord(input: SaveFoodRecordInput): Promise<FoodRecord> {
  const response = await apiRequest<ApiEnvelope<FoodRecord>>('food/records', {
    method: 'POST',
    body: JSON.stringify(input),
  })
  return response.data
}

export async function updateFoodRecord(
  id: string,
  input: Partial<SaveFoodRecordInput> & { version: number },
): Promise<FoodRecord> {
  const response = await apiRequest<ApiEnvelope<FoodRecord>>(`food/records/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  })
  return response.data
}

export async function deleteFoodRecord(id: string): Promise<void> {
  await apiRequest(`food/records/${encodeURIComponent(id)}`, { method: 'DELETE' })
}
